import { Injectable, computed, signal } from '@angular/core';
import { AbcAnalysisBaseMeasure } from '../types/abc-analysis-base-measure';
import { AbcAnalysisOverviewMaster } from '../types/abc-analysis-master';

/** Path-parameter state for the abc-analysis endpoints (baseMeasure/abcAnalysisId). The period is a filter item on SOFTLINE_FILTER_WWS_ABC_ANALYSIS. */
@Injectable()
export class AbcAnalysisFilterStateService {
  readonly baseMeasure = signal<AbcAnalysisBaseMeasure>('CONTRIBUTION_MARGIN');
  readonly abcAnalysisId = signal<number>(1);

  readonly master = computed<AbcAnalysisOverviewMaster>(() => ({
    baseMeasure: this.baseMeasure(),
    abcAnalysisId: this.abcAnalysisId(),
  }));
}
